// extracted by mini-css-extract-plugin
export default {"card":"ProjectCard_card__eiLM4","image":"ProjectCard_image__PImpz","details":"ProjectCard_details__a2Ii0","title":"ProjectCard_title__Jm1mh","meta":"ProjectCard_meta__IbWPW"};